/**
 * <strong>Purpose:</strong> <br>
 * Provides a shared set of functionality among all QAB widgets
 *
 * @module MW/toolstrip/mixins/QabWidgetMixin
 *
 * @copyright Copyright 2018-2019 The MathWorks, Inc.
 */
define([
    "dojo/_base/declare",
    "mw-form/mixins/property/DescriptionMixin",
    "MW/toolstrip/mixins/property/ShowTextMixin"
], function (declare, DescriptionMixin, ShowTextMixin) {

    var qabWidgetMixin = declare(null, {
        qabWidget: true,
        _showTextWasTrue: false,

        _setShowTextAttr: function () {
            this.inherited(arguments);

            // We never want to have this value return to false
            if (this.get("showText")) {
                this._showTextWasTrue = true;
            }

            this._updateTooltip(this.get("showText"));
        },
        
        /* Override MW/toolstrip/mixins/property/TooltipMixin */
        _updateTooltipLayout: function (tooltipLabel, tooltipShortcut, tooltipDescription) {
            var firstBuffer = "",
                secondBuffer = "";
            
            if (tooltipLabel) {
                if (tooltipShortcut) {
                    firstBuffer = " (";
                    secondBuffer = ")";
                    tooltipLabel = tooltipLabel;
                }
                if (tooltipDescription) {
                    secondBuffer += " - ";
                    tooltipDescription = tooltipDescription;
                }
            } else if (tooltipShortcut && tooltipDescription) {
                // To maintain backward consistency, we flip the order of description
                // and shortcut if they are the only two parts of the tooltip.
            
                tooltipLabel = tooltipDescription;
                tooltipDescription = "";
                firstBuffer = " (";
                secondBuffer = ")";
            }

            this._updateTitleInDOM(tooltipLabel.replace(/\n/g, " ") + firstBuffer + tooltipShortcut.replace(/\n/g, " ") + secondBuffer + tooltipDescription.replace(/\n/g, " "));
        }
    });

    /* ShowTextMixin depends on TooltipMixin, so we don't need to declare the dependency here */
    qabWidgetMixin._dependencies = [
        {mixin: DescriptionMixin, orderDependent: true},
        {mixin: ShowTextMixin, orderDependent: true}
    ];

    return qabWidgetMixin;

});